import { c as _c } from "react/compiler-runtime";
import { Typography } from "@/shared/ui/atoms";
import { DirectionIcon } from "@/shared/ui/atoms";
import { AllTreatmentCarousel } from "@/widgets/treatment-case/ui/organisms";
import { TreatmentCaseSummaryResponse } from "@/shared/types/type/treatment";
import useTreatmentCaseUIStore from "@/widgets/treatment-case/model/ui/store";
import { CustomButton } from "@/shared/ui/molecules";
interface AllTreatmentCardProps {
  content: {
    categoryId: number;
    categoryName: string;
    description: string;
    summaryList: TreatmentCaseSummaryResponse[];
  };
}
const AllTreatmentCard = t0 => {
  const $ = _c(17);
  const {
    content
  } = t0;
  const {
    categoryId,
    categoryName,
    description,
    summaryList
  } = content;
  const setSelectedCategoryId = useTreatmentCaseUIStore(_temp);
  let t1;
  if ($[0] !== categoryId || $[1] !== setSelectedCategoryId) {
    t1 = () => setSelectedCategoryId(categoryId);
    $[0] = categoryId;
    $[1] = setSelectedCategoryId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== categoryName) {
    t2 = <Typography size={20} className="text-gray-900 font-bold">{categoryName}</Typography>;
    $[3] = categoryName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DirectionIcon size={24} className="text-gray-500" rotate={270} />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2) {
    t4 = <CustomButton className="w-full flex items-center justify-between py-2.5 px-4" onClick={t1}>{t2}{t3}</CustomButton>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== description) {
    t5 = <Typography size={15} className="text-gray-600 px-4">{description}</Typography>;
    $[9] = description;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== summaryList) {
    t6 = <AllTreatmentCarousel summaryList={summaryList} />;
    $[11] = summaryList;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div className="pt-[14px]">{t4}{t5}{t6}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default AllTreatmentCard;
function _temp(s) {
  return s.setSelectedCategoryId;
}